module.exports = __webpack_public_path__ + "static/media/barely.ba06f07a.mp3";